<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <!-- <div class="text-right mb-3">
                            <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right mt-2" :hidden="btnNuovoSettingHidden" @click="onClickNuovaUscita" class="mb-2">
                                <b-icon icon="plus"> </b-icon>
                                Nuovo Setting
                            </b-button>
                        </div> -->
                <b-row class="sa-label-info">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>

            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="oggetti" :fields="colonne" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>

                        <template v-slot:cell(eventi)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Visualizza Setting" variant="outline-secondary" @click="onClickView(item)">
                                    <font-awesome-icon icon="eye" />
                                </b-button>

                                <b-button size="sm" v-b-tooltip.hover title="Modifica Setting" variant="outline-success" @click="onClickEdit(item)"> <font-awesome-icon icon="edit" /> </b-button>

                                <!-- (riga.oggetti, riga.index, $event.target) -->
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>

            <rsa-configurazione-settings-edit-component ref="cmpRsaConfigurazioneSettingsEdit" @onSave="onSaveSetting" @closeModal="loadSettingData"> </rsa-configurazione-settings-edit-component>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaConfigurazioneSettingsEditComponent from "./RsaConfigurazioneSettingsEditComponent.vue";

export default {
    components: {
        RsaConfigurazioneSettingsEditComponent,
    },

    watch: {
        currentPage() {
            let me = this;
            me.loadSettingData();
        },
    },

    mixins: [UtilityMixin],

    data() {
        return {
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsasettings",
            oggetti: [],
            filtroItems: [],
            rows: 0,
            btnNuovoSettingHidden: false,
            filtroSettings: { settings: "", codice: "" },
            showModalLoading: false,
            colonne: [
                {
                    label: "*",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 0.5rem",
                },
                {
                    label: "Settings",
                    key: "setting",
                    thStyle: "width: 15rem",
                    sortable: true,
                },
                {
                    label: "Codice",
                    key: "codice",
                    thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Note",
                    key: "note",
                    thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    class: "text-right",
                    key: "eventi",
                    label: "",
                    sortable: false,
                    thStyle: "width: 5rem",
                },
            ],
        };
    },

    mounted() {
        let me = this;
        me.id = this.$route.params.id;
    },

    methods: {
        loadSettingData() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroSettings"]) {
                me.filtroSettings = JSON.parse(sessionStorage["filtroSettings"]);
                me.$emit("updateFilter", me.filtroSettings);
            }
            me.filtroSettings.page = me.currentPage;
            me.filtroSettings.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroSettings, me.loadSettingDataSuccess, me.loadSettingDataError);
        },

        loadSettingDataSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.oggetti = [];
            me.oggetti = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
        },
        loadSettingDataError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore nel caricamento dei dati", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        /*  loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroSettings"]) {
                me.filtroSettings = JSON.parse(sessionStorage["filtroSettings"]);
            }
            let link = process.env.VUE_APP_PATH_API + this.pathResource;
            me.filtroSettings.page = me.currentPage;
            me.filtroSettings.forPage = me.perPage;
            axios
                .get(link, { params: me.filtroSettings })
                .then((risposta) => {
                    me.oggetti = [];
                    me.oggetti = risposta.data.data.list;
                    me.rows = risposta.data.data.recordsNumber;
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch((errore) => {
                    console.error("Errore nel caricamento dei dati", errore);
                    this.$$bvToast.toast("Errore nel caricamento dei dati", {
                        title: "Errore",
                        variant: "danger",
                    });
                })
                .finally(() => {
                    this.showModalLoading = false;
                }); */

        onClickView(oggetti) {
            let me = this;
            me.$router.push("/rsasettings/view/" + oggetti.id);
        },
        onClickEdit(item) {
            let me = this;
            me.$refs.cmpRsaConfigurazioneSettingsEdit.show(item);
        },

        onClickNuovoSetting() {
            let me = this;
            me.$refs.cmpRsaConfigurazioneSettingsEdit.show({
                id: null,
                setting: null,
                codice: null,
                note: null,
            });
        },

        onSaveSetting() {
            let me = this;
            me.loadSettingData();
        },
    },
};
</script>
